import axios from "axios";

const getUserAttributes = async (userId) => {
  let url = `${process.env.REACT_APP_GET_COGNITO_ATTRIBUTES}${userId}`;
  const res = await axios.get(url, {
    headers: {
      "Content-Type": "application/json",
    },
  });

  return res.data;
};

export default getUserAttributes;
